/* global Blockly */
/* global Util */

import CoreResponse from './CoreResponse';

// default/empty boolean block used as a auto-generated response block
const BooleanResponse = function () {
    let name = 'boolean_response';

    let blockInstance = CoreResponse({
        shape: Blockly.OUTPUT_SHAPE_HEXAGONAL,
        type: "Boolean"
    });
    Blockly.Blocks[name] = blockInstance;

    Blockly.JavaScript[name] = function() {
        let code = this.getJavascriptCore();
        return [code, Blockly.JavaScript.ORDER_NONE];
    };
};

export default BooleanResponse;
